import hmacSha256 from 'crypto-js/hmac-sha256'

// encode !'()*
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURIComponent
function fixedEncodeURIComponent(s: string) {
  return encodeURIComponent(s).replace(/[!'()*]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16)
  })
}

function signQuery(query: Record<string, string>, secret: string) {
  const keys = Object.keys(query).sort()
  let queryString = keys
    .filter((key) => query[key])
    .map((key) => `${key}=${fixedEncodeURIComponent(query[key])}`)
    .join('&')

  const timestamp = String(new Date().getTime())
  queryString = `${queryString}&timestamp=${timestamp}`

  return {
    ...query,
    timestamp,
    sign: hmacSha256(queryString, secret).toString().toUpperCase(),
  }
}

// HACK: as same as Global.d.ts
export enum API_ENV {
  DEMO = 'demo',
  PRE = 'pre',
  PROD = 'prod',
}

export interface ApiResponse<T> {
  dataInfo: T
  status: number
  msg?: string
  // other type of error
  error?: string
  message?: string
}

export interface FetchOption extends RequestInit {
  data?: Record<string, string | number | null | undefined>
  apiEnv?: API_ENV
  locationRedirect?: boolean
}

async function request<T>(fetchURL: string, fetchOption: FetchOption = {}) {
  // env init
  const apiEnv = fetchOption.apiEnv || window.CHARGESPOT_API_ENV
  const apiConfig = window.CHARGESPOT_API_CONFIG[apiEnv]

  // generate final URL
  let url
  // handle relative path
  if (fetchURL.startsWith('/')) {
    // CORS on production server
    const origin = apiConfig.origin
    url = new URL(fetchURL, origin)
  } else {
    url = new URL(fetchURL)
  }
  const finalData: FetchOption['data'] = fetchOption.data || {}

  // mapped to Record<string, string>
  const convertedData = Object.keys(finalData).reduce(
    (prev, key) => ({ ...prev, [key]: String(finalData[key]) }),
    {}
  )

  const signedData = signQuery(convertedData, apiConfig.SECRET)

  const method = fetchOption.method || 'GET'
  if (['POST', 'PUT'].includes(method)) {
    fetchOption.body = new URLSearchParams(signedData).toString()
  } else {
    url.search = new URLSearchParams(signedData).toString()
  }

  const res = await fetch(url.toString(), {
    ...fetchOption,
    method,
    headers: {
      // TODO: use real version
      Version: '1.0.0',
      Terminal: apiConfig.TERMINAL,
      Authorization: apiConfig.AUTHORIZATION,
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  })

  return res.json() as Promise<ApiResponse<T>>
}

export default request
